import PropTypes from 'prop-types';
import Pixel from 'react-facebook-pixel';

let initialized = false;

const FacebookPixel = ({ isPreview, result: { organizationFeatures, facebookPixel } }) => {
  if (!organizationFeatures || isPreview) return null;
  const hasFeature = organizationFeatures.findIndex(({ name }) => name === 'fb-pixel') > -1;
  if (hasFeature && facebookPixel) {
    initialized = true;
    Pixel.init(facebookPixel);
  }
  return null;
};

FacebookPixel.propTypes = {
  isPreview: PropTypes.bool.isRequired,
  result: PropTypes.shape().isRequired,
};

export const isInitialized = () => initialized;
export const pixel = Pixel;
export default FacebookPixel;
